module.exports = __webpack_public_path__ + "static/media/mobile-yakuza-cover.bc84eede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/mobile-yakuza-cover.jpg
// module id = 594
// module chunks = 0